var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$parent.loaded)?_c('div',{staticClass:"container-fluid flex-fill"},[_c('h1',[_vm._v("Administration")]),_c('p',[_vm._v("En construction")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }